import React, { useEffect, useState } from 'react';
import { Container, Typography, Paper } from '@mui/material';
import DashboardLayout from '../../Sidebar/DashboardLayout';
import GenericTable from '../../../commun/GenericTable';
import TableFilterControls from '../../../commun/TableFilterControls';
import Pagination from '../../../commun/Pagination';
import axios from 'axios';
import './logsView.css';
import Chatbox from '../../../commun/ChatBox';

const LogsView = () => {
  const [displayMode, setDisplayMode] = useState('table');

  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [search, setSearch] = useState('');
  const [level, setLevel] = useState('');
  const [page, setPage] = useState(1);
  const userRole = localStorage.getItem('userType');

  const itemsPerPage = 15; 
  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/logs`);
        setLogs(res.data);
        setFilteredLogs(res.data);
      } catch (err) {
        console.error('Erreur lors du chargement des logs', err);
      }
    };
    fetchLogs();
  }, []);

  useEffect(() => {
    let filtered = logs;

    if (search) {
      filtered = filtered.filter(log =>
        log.message.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (level) {
      filtered = filtered.filter(log => 
        log.level.toLowerCase() === level.toLowerCase()
      );
    }

    setFilteredLogs(filtered);
    setPage(1);
  }, [search, level, logs]);

  const columns = [
    { 
      key: 'timestamp', 
      label: 'Date', 
      render: (val) => new Date(val).toLocaleString() 
    },
    { 
      key: 'level', 
      label: 'Niveau', 
      render: (val) => (
        <span className={`log-level ${val.toLowerCase()}`}>
          {val.toUpperCase()}
        </span>
      )
    },
    { 
      key: 'message', 
      label: 'Message', 
      render: (val) => <span className="log-message">{val}</span> 
    }
  ];

  const paginatedLogs = filteredLogs.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  return (
    <DashboardLayout>
      <Container maxWidth="lg">
        <Typography variant="h5" className="logs-title">
          Fichier de logs
        </Typography>

        <div className="logs-filters">
          <TableFilterControls
            searchValue={search}
            onSearchChange={setSearch}
            statusValue={level}
            onStatusChange={setLevel}
            statusLabel="Niveau"
            statusOptions={[
              { value: '', label: 'Tous' },
              { value: 'info', label: 'Info' },
              { value: 'warn', label: 'Avertissement' },
              { value: 'error', label: 'Erreur' }
            ]}
          />
        </div>

        <Paper elevation={3} className="logs-table">
          <GenericTable data={paginatedLogs} columns={columns}    displayMode={displayMode}
  setDisplayMode={setDisplayMode}/>
        </Paper>

        <Pagination
          page={page}
          setPage={setPage}
          totalItems={filteredLogs.length}
        />
      </Container>
      {userRole !== 'agent' && <Chatbox userRole={userRole} />}
    </DashboardLayout>
  );
};

export default LogsView;
